import * as yup from 'yup';

export const permissionValidationSchema = () =>
  yup.object().shape({
    authorId: yup.number().required(),
    recipientRoles: yup.array().of(yup.number()).min(1)
  });

export const isStepValid = (step, values) => {
  switch (step) {
    case 0:
      return permissionValidationSchema().isValidSync(values);
    default:
      return false;
  }
};
